import { render, staticRenderFns } from "./consultationRecordDialog.vue?vue&type=template&id=da5a159e&scoped=true"
import script from "./consultationRecordDialog.vue?vue&type=script&lang=js"
export * from "./consultationRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./consultationRecordDialog.vue?vue&type=style&index=0&id=da5a159e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5a159e",
  null
  
)

export default component.exports